import { AddOutlined, DeleteOutlined, MoreHorizOutlined } from '@mui/icons-material';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, PopoverOrigin, Stack } from '@mui/material';
import { PageHeaderStatic, PageTitle } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { useCockpitPageHeader } from './CockpitPageHeader.hook';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export const CockpitPageHeader = () => {
  const { t } = useTranslation(I18nNamespace.cockpit, { keyPrefix: 'Cockpit' });
  const { isDetailPage, newTask, deleteTask, isLoading, menuProps, buttonProps } = useCockpitPageHeader();

  return (
    <PageHeaderStatic
      sx={{
        minHeight: 64,
      }}
      title={<PageTitle title={t('title')} />}
      maxWidth={false}
      right={
        isDetailPage ? (
          <Stack spacing={2} direction="row" alignItems="center">
            <Button variant="outlined" color="primary" {...buttonProps} disabled={isLoading} sx={{ minHeight: '40px' }}>
              <MoreHorizOutlined />
            </Button>
            <Menu anchorOrigin={ANCHOR_ORIGIN} transformOrigin={TRANSFORM_ORIGIN} {...menuProps}>
              <div>
                <MenuItem onClick={deleteTask}>
                  <ListItemIcon>
                    <DeleteOutlined fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={t('actions.delete')} />
                </MenuItem>
              </div>
            </Menu>
            <Button onClick={newTask} variant="contained" color="primary" size="medium" startIcon={<AddOutlined />}>
              {t('actions.create')}
            </Button>
          </Stack>
        ) : null
      }
    />
  );
};
